import React, { PropTypes } from 'react';
import Helmet from "react-helmet";




    var grafik = {
        "usatrends": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusPoll&competitionId=pw_usa&language=sv"
        , "usatrendslinjal": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusPoll&standaloneDetail=status&competitionId=pw_usa&language=sv"
        , "usatrendskarta": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusPoll&standaloneDetail=map&competitionId=pw_usa&language=sv"
        , "usalatest": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusLive&competitionId=pw_usa&language=sv"
        , "usalatestlinjal": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusLive&standaloneDetail=status&competitionId=pw_usa&language=sv"
        , "usalatestkarta": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusLive&standaloneDetail=map&competitionId=pw_usa&language=sv"
        , "usakongress": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=congress&competitionId=pw_usa&language=sv"
        , "frankrikefirst": "https://dpa-electionslive.s3.amazonaws.com/customers/praesidentschaftswahl-frankreich/aws/svt/html/index.html?competitionId=pw_fr&language=sv&pathTarget=_top&standalone=ranking&resultType=auto&widgetHeader=false&widgetFooter=false"
        , "frankrikesecond": "http://dpa-electionslive.s3.amazonaws.com/customers/praesidentschaftswahl-frankreich/aws/svt/html/index.html?competitionId=pw_fr&language=sv&pathTarget=_top&standalone=ranking&seasonArchive=s2017_final&resultType=auto&widgetHeader=false&widgetFooter=false"
    };



class Pym extends React.Component {



  componentDidMount() {

    const {value} = this.props;


    var checkPym = setInterval(function(){
      if (window.pym != undefined){
        clearInterval(checkPym);
        new window.pym.Parent(value, grafik[value]);
      }

    },300);

  }
  render()  {
    const {value} = this.props;
    const style = require('./dpa.scss');


    return (
      <div>


      <Helmet
      script={[{"src": "http://uswahl-dpa-electionslive.s3.amazonaws.com/pw_usa/assets/js/pym.min.js", "type": "text/javascript"}]}
      />
      <div id={value} className={style.wrapper}></div>

      </div>


    );


  }
}


Pym.propTypes = {
  value: PropTypes.string
};

export default Pym;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/dpa/dpa.js
 **/